export default {
  namespaced: true,
  state: {
    videoId: -1
  },
  getters: {
    getVideoId: (state) => state.videoId
  },
  mutations: {
    setVideoId(state, payload) {
      state.videoId = payload
    }
  }
}
